// removed by extract-text-webpack-plugin
module.exports = {"btn":"CloseButton__btn__VQ6GN","span-first-off":"CloseButton__span-first-off__1Kizo","span-second-off":"CloseButton__span-second-off__2iKaF","span-third-off":"CloseButton__span-third-off__1CWxs","on":"CloseButton__on__3IBnA","span-first-on":"CloseButton__span-first-on__iyCZ_","span-second-on":"CloseButton__span-second-on__2g9JM","span-third-on":"CloseButton__span-third-on__2Vxsp"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/UI/Button/CloseButton/CloseButton.css
// module id = 309
// module chunks = 0